import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { addSegmentToList, initializeUserSegmentArray } from "@ponder-features/header/navbar/navbar.component";
import { UserSettingsCategory } from "./user-settings-category";
import { Subscription } from "rxjs";
import { UserAccountCategoryButtonComponent } from "./user-account-category-button.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { UnauthorizedComponent } from "@ponder-shared/components/unauthorized.component";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { RouterOutlet } from "@angular/router";

@Component({
    imports: [
        RouterOutlet,
        UserAccountCategoryButtonComponent,
        UnauthorizedComponent,
        LoadingComponent
    ],
    templateUrl: "./user-account.component.html"
})
export class UserAccountComponent {
    public isLoading: boolean = true;
    public authSession?: AuthSession;
    public username?: string;
    public svgIcons = SvgIcon;
    public settingsCategories = UserSettingsCategory;
    public selectedCategory: UserSettingsCategory = UserSettingsCategory.General;

    private categorySelectedSub!: Subscription;

    public constructor(private events: EventBroker, private auth: AuthService, private pageTitle: Title) {
        this.categorySelectedSub = this.events.account.categorySelected.subscribe({
            next: (category: UserSettingsCategory) => {
                this.onCategorySelected(category);
            }
        })
    }

    public ngOnDestroy(): void {
        this.categorySelectedSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            this.authSession = authSession;
            this.username = authSession?.username;
            this.isLoading = false;
            
            if (this.username) {
                this.pageTitle.setTitle(`Ponder > ${this.username} > Account`);
                this.sendNavbarUpdate();
            }
        });
    }
    
    private sendNavbarUpdate(): void {
        var segments = initializeUserSegmentArray(this.username!);
        addSegmentToList(segments, "Account", "Account");
        
        this.events.ui.navbarUpdateEvent.emit(segments);
    }

    private onCategorySelected(category: UserSettingsCategory): void {
        this.selectedCategory = category;
    }
}